import { IdentityVerificationDocumentTypes } from "./IdentityVerificationDocumentTypes";
import { IdentityVerificationDocumentSides } from "./IdentityVerificationDocumentSides";

export const IDENTITY_VERIFICATION_SIDES_PER_DOCUMENT_TYPE: {
  [key in IdentityVerificationDocumentTypes]: IdentityVerificationDocumentSides[];
} = {
  [IdentityVerificationDocumentTypes.ID_CARD]: [
    IdentityVerificationDocumentSides.FRONT,
    IdentityVerificationDocumentSides.BACK,
  ],
  [IdentityVerificationDocumentTypes.DRIVER_LICENSE]: [
    IdentityVerificationDocumentSides.FRONT,
    IdentityVerificationDocumentSides.BACK,
  ],
  [IdentityVerificationDocumentTypes.PASSPORT]: [IdentityVerificationDocumentSides.FRONT],
  [IdentityVerificationDocumentTypes.RESIDENCE_PERMIT]: [
    IdentityVerificationDocumentSides.FRONT,
    IdentityVerificationDocumentSides.BACK,
  ],
};
